module.exports = __webpack_public_path__ + "static/media/student38.d4583f4e.png";